import renderBundlesApp from './bundles/index';

window.bundles = {
  renderApp: renderBundlesApp,
};
